export const photoCounter = { count: 0 };



// WEBPACK FOOTER //
// ./scripts/_states.js